import React, {useState, useEffect, useRef, useMemo} from "react";
import { Link , useParams, useNavigate, useLocation  } from "react-router-dom";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import {Links} from '../routes/PathLink'
import Input from '../components/ui/input.jsx';
import {
  useIndicesQuery
} from '../data/indices-details';


import Breadcrumb  from "../components/Breadcrumb";
import IndicesTable  from "../components/IndicesTable";
import {APP_URL, APP_NAME} from 'components/config/Common'
import Seo from 'components/seo/seo'
import { BsSearch } from "react-icons/bs";

const Indices = () => {	
	const navigate = useNavigate();
	const {slug} = useParams()
	
	
	const [metaTitle, setMetaTitle] = useState('Stock Market Indices')
	const [metaDesc, setMetaDesc] = useState('Discover various market Indices and explore their details on our platform.')
	const [user_type, setUser_type] = useState('');
    const [snipetData, setSnipetData] = useState('');

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    const [orderBy, setOrder] = useState('created_at');
    const [sortedBy, setColumn] = useState('desc');
  
    // SORTING
    const [sortInfo, setSortInfo] = useState({ key: null, order: null });
    const { search } = useLocation();
    const parameters = new URLSearchParams(search);
    let status_p = parameters.get('status');
    let show_p = parameters.get('show');
    const [searchQuery, setSearchQuery] = useState(null);
  
	//console.log("slug",slug);
	const {
		sectors,
        sectorDetails,
        paginatorInfo,
		isLoading,
		error,
	} = useIndicesQuery({ 
        slug,
        limit: pageSize,
        page,    
        orderBy,
        sortedBy,
        search:searchQuery,
	});

const totalPages = Math.ceil(paginatorInfo?.total / pageSize);

const searchForum = (val) => {
      //console.log('sq---', val)
      setSearchQuery(val)
    }

const breadcrumb = [
  {
    name:'Home',
    link:`${process.env.REACT_APP_URL}`,
  },
  {
    name:`Indices`,
    link:null
  }
]

	return (
		<>
    <Seo 
        title={`${metaTitle} - ${APP_NAME}`}
        desc={metaDesc && metaDesc.substring(0, 200)}
        url={`${APP_URL}/indices`}
      />   
		<Header  />        
        <div className="space-y-5 px-5">
            <Breadcrumb breadcrumb={breadcrumb} />
            <section className="bg-white shadow-sm z-50 rounded-xl p-5">
              <div className="flex flex-col lg:flex-row items-center justify-between">
                <h2 className="text-2xl">Browse Indices</h2>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 top-3 flex items-center pl-3 pointer-events-none">
                  <BsSearch className="w-5 h-5 text-gray-400" />
                </div>
                <Input 
                  dimension='small' 
                  onChange={(e) => searchForum(e.target.value)} 
                  value={searchQuery}
                  placeholder='Search Indices by name...'
                  inputClassName="!px-12"
                />
                </div>
              </div>
                {/* <div className="mt-4 prose max-w-full" dangerouslySetInnerHTML={{__html: screenDetails?.description || ''}}></div> */}
                
                
                <>
                <IndicesTable 
                    data={sectors} 
                    pageSize={pageSize} 
                    isLoading={isLoading} 
                    paginatorInfo={paginatorInfo}
                    pageType={Links.INDICES}
                />
                </>               
    
            </section>
        </div>
       
		<Footer />
		
		
		</>
		);
};

export default Indices;